import type { FooterColumn } from '@/shared/types/layout.ts';
import { EXTERNAL_URL, PATHS } from './routes.constant.ts';

/**
 * Footer 컬럼 메뉴.
 *
 * Header navigationItems와 완전히 독립적으로 관리한다.
 *  - Footer는 단순 링크 컬럼만 있으므로 메가메뉴 구조를 변환·재사용할 이유가 없음.
 *  - Header에 추가한 항목이 Footer에서 자동으로 사라지지/생기지 않으므로 부수효과가 없다.
 *  - 컬럼 추가/수정 시 이 파일만 건드린다.
 *
 * 경로는 모두 PATHS 상수에서 가져온다. 하드코딩 금지.
 */
export const footerNavigation: readonly FooterColumn[] = [
  {
    id: 'product',
    title: '제품',
    links: [
      { id: 'xcost-pro', label: 'XCOST PRO', path: PATHS.PRODUCT_XCOST_PRO, badge: 'HOT' },
      { id: 'xpixels-aqc', label: 'XPIXELS AQC', path: PATHS.PRODUCT_XPIXELS_AQC },
      { id: 'xpixels-sqc', label: 'XPIXELS SQC', path: PATHS.PRODUCT_XPIXELS_SQC },
      // { id: 'xpixels-eqc', label: 'XPIXELS EQC', path: PATHS.PRODUCT_XPIXELS_EQC, badge: 'NEW' },
      // { id: 'xpixels-mqc', label: 'XPIXELS MQC', path: PATHS.PRODUCT_XPIXELS_MQC, badge: 'NEW' },
    ],
  },
  {
    id: 'support',
    title: '지원',
    links: [
      { id: 'contact', label: '문의', path: PATHS.SUPPORT_INQUIRIES },
      { id: 'faq', label: 'FAQ', path: PATHS.SUPPORT_FAQS },
    ],
  },
  {
    id: 'site',
    title: '공식 사이트',
    links: [
      { id: 'community', label: '커뮤니티', path: EXTERNAL_URL.COMMUNITY, target: '_blank' },
      { id: 'naver-band', label: '네이버 밴드', path: EXTERNAL_URL.NAVER_BAND, target: '_blank' },
      { id: 'naver-blog', label: '네이버 블로그', path: EXTERNAL_URL.NAVER_BLOG, target: '_blank' },
    ],
  },
];

/** Footer 하단 사업자 정보 + 카피라이트 */
export const FOOTER_LEGAL = {
  brand: '하우코스트',
  copyright: '© HOWCOST Co., Ltd. All Rights Reserved.',
  company: {
    name: '㈜하우코스트',
    ceo: '유현오',
    address:
      '경기도 수원시 권선구 수성로 8 경기중소기업성장지원센터 303호',
    businessNumber: '809-86-00250',
    mailOrderNumber: '제2026-수원권선-0172호',
    tel: '031-417-0466',
    emailSupport: 'support@howcost.co.kr',
    emailEstimate: 'estimate@howcost.co.kr',
  },
} as const;

export const footerSmallNavigation = [
  { id: 'about', label: '회사소개', path: PATHS.ABOUT, target: '_blank' },
  { id: 'legal-terms', label: '이용약관', path: PATHS.LEGAL_TERMS, target: '_blank' },
  // 법정 명칭 "개인정보 처리방침" + 다른 링크와 구분되는 강조 (개인정보 보호법 시행령 제31조)
  { id: 'legal-privacy', label: '개인정보 처리방침', path: PATHS.LEGAL_PRIVACY, target: '_blank', strong: true },
  { id: 'legal-refund', label: '환불·해지 정책', path: PATHS.LEGAL_REFUND, target: '_blank' },
];
